import { Plus } from "lucide-react";
import "./PlusSymbolCard.css";

type PlusSymbolCardProps = {
  size?: "sm" | "md" | "lg";
  message?: string;
  onClick?: () => void;
  className?: string;
};

const PlusSymbolCard = ({
  size = "md",
  message,
  onClick,
  className = "",
}: PlusSymbolCardProps) => {
  return (
    <div
      className={`plus-symbol-card plus-${size} ${className}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="plus-symbol-icon">
        <Plus size={size === "sm" ? 24 : size === "lg" ? 84 : 56} />
      </div>
      {message && <p className="plus-symbol-message">{message}</p>}
    </div>
  );
};

export default PlusSymbolCard;
